(function() {
	'use strict';

	angular.module('gatewayApp').controller('ManageCurrencyPairConfigurationViewController',
        ManageCurrencyPairConfigurationViewController);

            ManageCurrencyPairConfigurationViewController.$inject = [ '$scope', '$state', '$rootScope',
			'workflowSharedService', '$uibModalInstance', 'CurrencyPairConfiguration', 'entity',
			'Workflow', 'GlobalValues','StaticLookUp'];

	function ManageCurrencyPairConfigurationViewController($scope, $state, $rootScope,
			workflowSharedService, $uibModalInstance, CurrencyPairConfiguration, entity, Workflow,
			GlobalValues,StaticLookUp) {
		var vm = this;
		vm.clear = clear;
		vm.approveCurrencyPairConfiguration = approveCurrencyPairConfiguration;
		vm.rejectCurrencyPairConfiguration = rejectCurrencyPairConfiguration;
		vm.discardCurrencyPairConfiguration = discardCurrencyPairConfiguration;
		$scope.showButton = false;
		$scope.showDiscardButton = false;
		vm.clicked = false;
		vm.ExpandOrCollapseRedirectionURLConfigurations = false;
		vm.ExpandOrCollapseFeeConfigurations = false;
		vm.globalValues = GlobalValues;
		vm.CurrencyPairConfigurationDTO = {};
        vm.bankValue=null;
        vm.bank=null;
        vm.state=null;

		if (workflowSharedService.viewFrom == 'currencyPairConfiguration') {
			vm.currencyPairConfiguration = entity; 
			console.log(vm.currencyPairConfiguration); 
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'currency_pair_configurationtodolist_checker') {
			vm.currencyPairConfigurationDTO = angular.fromJson($rootScope.payload);

			if (vm.currencyPairConfiguration  == undefined) {
				vm.currencyPairConfiguration = vm.currencyPairConfigurationDTO
			}
			$scope.showButton = true;
			$scope.showDiscardButton = false;
		} else if (workflowSharedService.viewFrom == 'currency_pair_configurationtodolist_maker') {
			vm.currencyPairConfigurationDTO = angular.fromJson($rootScope.payload);
			if (vm.currencyPairConfiguration == undefined ||vm.currencyPairConfiguration == null) {
				vm.currencyPairConfiguration =  vm.currencyPairConfigurationDTO
			}
			$scope.showButton = false;
			$scope.showDiscardButton = true;
		} else if (workflowSharedService.viewFrom == 'currency_pair_configuration_auditLog') {
			vm.currencyPairConfigurationDTO = angular.fromJson($rootScope.payload);
		

			if (vm.currencyPairConfiguration == undefined) {
				vm.currencyPairConfiguration = vm.currencyPairConfigurationDTO
			}
			$scope.showButton = false;
		}
		
		function approveCurrencyPairConfiguration() {
			CurrencyPairConfiguration.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			$uibModalInstance.dismiss('cancel');
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
		}
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectCurrencyPairConfiguration() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardCurrencyPairConfiguration() {
			CurrencyPairConfiguration.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			$uibModalInstance.dismiss('cancel');
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
		}
		function onDiscardError(error) {

		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
